import React from "react";
import "./Services.css";

const Icon = {
  Tools: (p) => (
    <svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true" {...p}>
      <path d="M21 6.5l-2.8 2.8-3.5-3.5L17.5 3A6 6 0 0 0 10 10.5l-6.9 6.9a2.1 2.1 0 0 0 3 3l6.9-6.9A6 6 0 0 0 21 6.5zM6 19a1 1 0 1 1-2 0 1 1 0 0 1 2 0z"/>
    </svg>
  ),
  Delivery: (p) => (
    <svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true" {...p}>
      <path d="M3 7h11v7h2.5a2 2 0 0 1 1.7 1l1.5 2.5H21v2h-1a2.5 2.5 0 1 1-5 0H9a2.5 2.5 0 1 1-5 0H3v-2h1V7zm13 2h2l2 3v2h-4V9z"/>
    </svg>
  ),
  Support: (p) => (
    <svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true" {...p}>
      <path d="M12 2a9 9 0 0 0-9 9v3a3 3 0 0 0 3 3h2v-6H6a6 6 0 1 1 12 0h-2v6h2a3 3 0 0 0 3-3v-3a9 9 0 0 0-9-9z"/>
    </svg>
  ),
  Price: (p) => (
    <svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true" {...p}>
      <path d="M12 1l9 5v12l-9 5-9-5V6l9-5zm0 3.2L5 7.7v8.6l7 3.9 7-3.9V7.7l-7-3.5zM11 7h2v1.2c1.7.3 2.8 1.4 2.8 3H14c0-.7-.6-1.2-1.5-1.2S11 10.4 11 11s.5 1 1.6 1.2l.9.2c1.9.4 3 1.4 3 3 0 1.7-1.2 2.8-3.5 3.1V20h-2v-1.2c-2-.3-3.3-1.5-3.3-3.3h1.8c0 1 .8 1.6 2.1 1.6 1.4 0 2.1-.6 2.1-1.4 0-.7-.6-1.1-1.8-1.4l-1-.2c-1.7-.4-2.7-1.3-2.7-2.8 0-1.6 1.2-2.7 3.1-3V7z"/>
    </svg>
  ),
};

const services = [
  {
    icon: "Tools",
    title: "Quality Tools & Materials",
    desc: "Trusted brands for daily use and building projects—strong, durable, and reliable.",
    points: ["Power tools & hand tools", "Paints, cement, blocks", "Electrical & plumbing"],
  },
  {
    icon: "Delivery",
    title: "Fast Delivery",
    desc: "Quick delivery to your home or project site—safe handling and on-time support.",
    points: ["Same-day delivery (area)", "Careful packing", "Bulk order support"],
  },
  {
    icon: "Support",
    title: "Expert Guidance",
    desc: "Not sure what to buy? Tell us your requirement. We’ll recommend the best option.",
    points: ["Product suggestions", "Quantity estimation", "Friendly service"],
  },
  {
    icon: "Price",
    title: "Fair Prices",
    desc: "Best value for money with quality products—perfect for small and large projects.",
    points: ["Competitive pricing", "Discounts for bulk", "Clear quotations"],
  },
];

export default function Services() {
  return (
    <section className="svcPro" id="services">
      <div className="svcProContainer">
        <div className="svcProHead">
          <div>
            <p className="svcProKicker">Our Services</p>
            <h2 className="svcProTitle">
              Everything you need for <span>hardware</span> & projects
            </h2>
            <p className="svcProSub">
              Quality items, quick delivery, and friendly guidance—helping you build with confidence.
            </p>
          </div>

          <a className="svcProCta" href="#contact">
            Get a Quotation
          </a>
        </div>

        <div className="svcProGrid">
          {services.map((s) => {
            const Ico = Icon[s.icon];
            return (
              <article className="svcProCard" key={s.title}>
                <div className="svcProTop">
                  <div className="svcProIcon">
                    <Ico className="svcProSvg" />
                  </div>
                  <div className="svcProBadge">Premium</div>
                </div>

                <h3 className="svcProH3">{s.title}</h3>
                <p className="svcProDesc">{s.desc}</p>

                <ul className="svcProList">
                  {s.points.map((p) => (
                    <li key={p}>
                      <span className="svcProTick" aria-hidden="true">✓</span>
                      <span>{p}</span>
                    </li>
                  ))}
                </ul>
              </article>
            );
          })}
        </div>
      </div>
    </section>
  );
}
